import { Discount, Campaign } from '../../types/discounts';

export enum ActionTypes {
    FetchDiscounts = '[marketing/campaign/edit] FETCH_DISCOUNTS',
    FetchDiscountsResponse = '[marketing/campaign/edit] FETCH_DISCOUNTS_RESPONSE',
    FetchCampaign = '[marketing/campaign/edit] FETCH_CAMPAIGN',
    FetchCampaignResponse = '[marketing/campaign/edit] FETCH_CAMPAIGN_RESPONSE',
    ClearFetchedData = '[marketing/campaign/edit] CLEAR_FETCHED_DATA',
    UpdateCampaign = '[marketing/campaign/edit] UPDATE_CAMPAIGN',
    UpdateCampaignResponse = '[marketing/campaign/edit] UPDATE_CAMPAIGN_RESPONSE',
    UpdateDiscount = '[marketing/campaign/edit] UPDATE_DISCOUNT',
    UpdateDiscountResponse = '[marketing/campaign/edit] UPDATE_DISCOUNT_RESPONSE',
    CreateDiscount = '[marketing/campaign/edit] CREATE_DISCOUNT',
    CreateDiscountResponse = '[marketing/campaign/edit] CREATE_DISCOUNT_RESPONSE',
    DeleteDiscount = '[marketing/campaign/edit] DELETE_DISCOUNT',
    DeleteDiscountResponse = '[marketing/campaign/edit] DELETE_DISCOUNT_RESPONSE',
}

export interface FetchCampaign {
    type: ActionTypes.FetchCampaign;
    payload: {
        accountId: string;
        campaignId: string;
    };
}

export interface FetchCampaignResponse {
    type: ActionTypes.FetchCampaignResponse;
    payload: Campaign;
}

export const fetchCampaign = (accountId: string, campaignId: string): FetchCampaign => {
    return {
        type: ActionTypes.FetchCampaign,
        payload: {
            accountId,
            campaignId,
        },
    };
};

export interface FetchDiscounts {
    type: ActionTypes.FetchDiscounts;
    payload: {
        accountId: string;
        campaignId: string;
    };
}

export interface FetchDiscountsResponse {
    type: ActionTypes.FetchDiscountsResponse;
    payload: Discount[];
}

export const fetchDiscounts = (accountId: string, campaignId: string): FetchDiscounts => {
    return {
        type: ActionTypes.FetchDiscounts,
        payload: {
            accountId,
            campaignId,
        },
    };
};

export interface ClearFetchedData {
    type: ActionTypes.ClearFetchedData;
}

export const clearFetchedData = () => {
    return {
        type: ActionTypes.ClearFetchedData,
    };
};

export interface UpdateCampaign {
    type: ActionTypes.UpdateCampaign;
    payload: {
        accountId: string;
        campaign: Campaign;
        campaignId?: string;
    };
}

export interface UpdateCampaignResponse {
    type: ActionTypes.UpdateCampaignResponse;
    payload: Campaign;
}

export const updateCampaign = (accountId: string, campaign: Campaign): UpdateCampaign => {
    return {
        type: ActionTypes.UpdateCampaign,
        payload: {
            accountId,
            campaignId: campaign.campaign_id,
            campaign,
        },
    };
};

export interface UpdateDiscount {
    type: ActionTypes.UpdateDiscount;
    payload: {
        accountId: string;
        discount: Discount;
        discountId?: string;
    };
}

export interface UpdateDiscountResponse {
    type: ActionTypes.UpdateDiscountResponse;
    payload: Discount;
}

export const updateDiscount = (accountId: string, discount: Discount): UpdateDiscount => {
    return {
        type: ActionTypes.UpdateDiscount,
        payload: {
            accountId,
            discount,
            discountId: discount.id,
        },
    };
};

export interface CreateDiscount {
    type: ActionTypes.CreateDiscount;
    payload: {
        accountId: string;
        discount: Discount;
    };
}

export interface CreateDiscountResponse {
    type: ActionTypes.CreateDiscountResponse;
    payload: Discount;
}

export const createDiscount = (accountId: string, discount: Discount): CreateDiscount => {
    return {
        type: ActionTypes.CreateDiscount,
        payload: {
            accountId,
            discount,
        },
    };
};

export interface DeleteDiscount {
    type: ActionTypes.DeleteDiscount;
    payload: {
        accountId: string;
        discountId: string;
    };
}

export interface DeleteDiscountResponse {
    type: ActionTypes.DeleteDiscountResponse;
    payload: Discount;
}

export const deleteDiscount = (accountId: string, discountId: string): DeleteDiscount => {
    return {
        type: ActionTypes.DeleteDiscount,
        payload: {
            accountId,
            discountId,
        },
    };
};

export type Actions =
    | FetchDiscounts
    | FetchDiscountsResponse
    | FetchCampaign
    | FetchCampaignResponse
    | ClearFetchedData
    | UpdateCampaign
    | UpdateCampaignResponse
    | UpdateDiscount
    | UpdateDiscountResponse
    | CreateDiscount
    | CreateDiscountResponse
    | DeleteDiscount
    | DeleteDiscountResponse;
